import { render } from "./TournamentTeamsPlayers.vue?vue&type=template&id=5f579519&ts=true"
import script from "./TournamentTeamsPlayers.vue?vue&type=script&lang=ts"
export * from "./TournamentTeamsPlayers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Reports/TournamentTeamsPlayers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f579519"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f579519', __exports__)) {
    api.reload('5f579519', __exports__)
  }
  
  module.hot.accept("./TournamentTeamsPlayers.vue?vue&type=template&id=5f579519&ts=true", () => {
    api.rerender('5f579519', render)
  })

}


export default __exports__